import {
  Terminal as TerminalClient,
  type TerminalId,
} from "@modules/terminal-client";
import { useTerminalServerUrl } from "@/hooks/useTerminalServerUrl";
import { terminalStyle } from "./theme";

interface Props {
  terminalId: string;
  onExit?: () => void;
}

export const Terminal = ({ terminalId, onExit }: Props) => {
  const terminalServerUrl = useTerminalServerUrl();

  return (
    <TerminalClient
      url={terminalServerUrl}
      terminalId={terminalId as TerminalId}
      upsert
      createOptions={{
        cwd: "/app",
        shell: "/bin/bash",
        env: {
          PS1: "\\[\\e[1m\\]\\\\$\\[\\e[0m\\] ",
        },
      }}
      onExit={onExit}
      {...terminalStyle}
    />
  );
};
